/** Suggested vibe words. Any other word the prospect types is stored too. */
export const UNIT_ANALYSIS_VIBES = [
  'Cozy',
  'Snug',
  'Serene',
  'Airy',
  'Minimal',
  'Moody',
  'Chic',
  'Boho',
  'Retro',
  'Social-ready',
  'Spacious',
  'Sleeper',
  'Quiet',
  'Mid',
  'Understated',
  'Immaculate',
  'Mellow',
  'Nesty',
  'Movie-night ready',
  'Golden hour',
  'Sunday reset',
  'Friendsgiving-ready',
  'Kitchen-party',
  'Come-over-anytime',
  'Open-door vibe',
  'Instagrammable',
  'Quirky',
  'Iconic',
  'Obsessed',
  'Peak',
  'Sterile',
  'Dated',
  'Cluttered',
] as const;
